import React from 'react';
import { Section } from './ui/Section';
import { BundleCard } from './BundleCard';
import { Timer, ShieldCheck, Lock, Truck, Star } from 'lucide-react';
import { OfferCountdown } from './OfferCountdown';
export function PricingBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const checkoutUrl = 'https://glowliftessencemx.com/products/stingfit-premium-1';
  const bundles = [{
    quantity: 1,
    price: '$599 MXN',
    originalPrice: '$1,200 MXN',
    savings: 50,
    bonuses: [],
    productImage,
    perDayOverride: '6,65'
  }, {
    quantity: 2,
    price: '$899 MXN',
    originalPrice: '$2,400 MXN',
    savings: 63,
    bonuses: [],
    productImage,
    perDayOverride: '4,99'
  }, {
    quantity: 3,
    price: '$1,199 MXN',
    originalPrice: '$3,600 MXN',
    savings: 67,
    isBestValue: true,
    bonuses: [],
    productImage,
    perDayOverride: '4,44'
  }];
  return <Section id="pricing" className="pt-12" data-id="element-1140">
      <div className="text-center mb-10" data-id="element-1141">
        <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-4 py-2 rounded-full text-sm font-black mb-4 border border-red-100 uppercase tracking-wide" data-id="element-1142">
          <Timer className="w-4 h-4" data-id="element-1143" />⚡ Oferta por Tiempo Limitado — Precios
          Suben Pronto
        </div>

        <OfferCountdown data-id="element-1144" />

        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-1145">
          Elige tu Pack y Empieza <span className="text-[#D4AF37]" data-id="element-1146">Hoy</span>
        </h2>
        <p className="text-gray-600 text-lg mb-2" data-id="element-1147">
          El <strong data-id="element-1148">78% de nuestras clientas</strong> eligen el pack de 3 meses
          para resultados óptimos y duraderos.
        </p>
        <p className="text-sm text-red-600 font-bold animate-pulse" data-id="element-1149">
          ⚠️ Precio especial activo solo mientras dure el stock
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 items-end mb-10 max-w-4xl mx-auto" data-id="element-1150">
        {bundles.map((bundle, i) => <BundleCard key={i} {...bundle} onSelect={() => {
        window.location.href = checkoutUrl;
      }} data-id="element-1151" />)}
      </div>

      {/* Trust strip */}
      <div className="bg-[#2D5016] rounded-2xl p-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-6" data-id="element-1152">
        <div className="flex flex-col items-center gap-1.5" data-id="element-1153">
          <Truck className="w-6 h-6 text-[#D4AF37]" data-id="element-1154" />
          <p className="text-white font-bold text-sm" data-id="element-1155">Envío Gratis</p>
          <p className="text-green-300 text-xs" data-id="element-1156">A todo México</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-1157">
          <ShieldCheck className="w-6 h-6 text-[#D4AF37]" data-id="element-1158" />
          <p className="text-white font-bold text-sm" data-id="element-1159">Garantía 90 Días</p>
          <p className="text-green-300 text-xs" data-id="element-1160">Devolución total</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-1161">
          <Lock className="w-6 h-6 text-[#D4AF37]" data-id="element-1162" />
          <p className="text-white font-bold text-sm" data-id="element-1163">Pago Seguro</p>
          <p className="text-green-300 text-xs" data-id="element-1164">SSL 256-bit</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-1165">
          <Star className="w-6 h-6 fill-[#D4AF37] text-[#D4AF37]" data-id="element-1166" />
          <p className="text-white font-bold text-sm" data-id="element-1167">4.9/5 Estrellas</p>
          <p className="text-green-300 text-xs" data-id="element-1168">+10,000 reseñas</p>
        </div>
      </div>

      {/* Payment methods */}
      <div className="flex justify-center items-center gap-3 flex-wrap mb-6" data-id="element-1169">
        <p className="text-xs text-gray-400 font-medium" data-id="element-1170">
          Métodos de pago aceptados:
        </p>
        {['VISA', 'Mastercard', 'Amex', 'PayPal', 'OXXO', 'Contra Entrega'].map(m => <span key={m} className="bg-gray-100 text-gray-600 text-xs font-bold px-3 py-1.5 rounded-lg border border-gray-200" data-id="element-1171">
              {m}
            </span>)}
      </div>

      <div className="text-center" data-id="element-1172">
        <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-1173">
          *Los resultados pueden variar de una persona a otra. Este producto no
          está destinado a diagnosticar, tratar, curar o prevenir ninguna
          enfermedad. Complemento a una dieta equilibrada y ejercicio.
        </p>
      </div>
    </Section>;
}